import React, { useState, useEffect } from 'react';
import { DropDown } from '../../commons';
import "react-datepicker/dist/react-datepicker.css";
import ReportsDateSelect from '../../commons/ReportsDateSelect/ReportsDateSelect';
import { useLocation } from 'react-router-dom';

type AppProps = {
  startDate?: any;
  endDate?: any;
  allStockItemList: any;
  handleStartDateChange: (date: any) => void;
  handleEndDateChange: (date: any) => void;
  handleSubmitData?: (data: any) => void;
  toggle: boolean;
  setToggle: (data: boolean) => void;
};

const StockStatementHeader = ({
  startDate,
  endDate,
  handleStartDateChange,
  handleEndDateChange,
  handleSubmitData,
  allStockItemList,
  toggle,
  setToggle
}: AppProps) => {
  const search = useLocation().search;
  const redirectStockItemName = localStorage.getItem("stock_item_name");
  const sku_id = new URLSearchParams(search).get('sku_id');

  const [stockItemName, setStockItemName] = useState({
    value: "",
    label: "Select Stock Name..",
  })
  const option: any = allStockItemList?.map((data: any) => {
    return {
      value: data.stock_item_id,
      label: data.stock_item_name,
    }
  })

  useEffect(() => {
    if(redirectStockItemName&&sku_id){
      setStockItemName({
        value: sku_id,
        label: redirectStockItemName
      })
    }
  }, [redirectStockItemName])

  const getStockStatement = () => {
    if (stockItemName?.value) {
      const data = {
        skuId: stockItemName?.value,
        stockItemName: stockItemName?.label
      }
      handleSubmitData?.(data)
    }
  }

  const handleSetStockItemName = (mode: any) => {
    setStockItemName({
      value: mode?.value,
      label: mode?.label
    })
  }

  return (
    <div className='d-flex justify-content-start align-items-center'>
      <div className="col-md-3 form-group">
        <label>Stock Name</label>
        <div>
          <DropDown
            extraClasses="zindex-2"
            options={option}
            value={stockItemName}
            handleChange={handleSetStockItemName}
          />
        </div>
      </div>
      <div className='form-group'>
        <label>Date</label>
        <div>
          <ReportsDateSelect
            type={"stockStatement"}
            setToggle={setToggle}
            toggle={toggle}
            startDate={startDate}
            endDate={endDate}
            handleStartDateChange={handleStartDateChange}
            handleEndDateChange={handleEndDateChange}
          />
        </div>
      </div>
      <div className="col-md-3 mt-2">
        <button
          className="btn btn-primary"
          onClick={getStockStatement}
          disabled={!startDate?.length || !endDate?.length || !stockItemName?.value}
        >
          Get Stock Statement
        </button>
      </div>
    </div>
  )
};

export default StockStatementHeader;